import { inject } from '@angular/core';
import { CanActivateFn, Router, UrlTree } from '@angular/router';
import { isJkuHost } from '../auth/login-options';

/**
 * Sends the root of the JKU hostname to the webshop instead of the JJames parker home page.
 *
 * Without this, a visitor arriving at parken.jku.at from the JKU homepage lands on
 * {@link HomeComponent} inside the JJames shell — nobody is authenticated yet, so neither
 * `isJkuSso()` nor the URL check in AppComponent has anything to key off — and has to find a Login
 * button. That is the same thing JKU rejected about the shared Keycloak login page, one step
 * earlier: a JJames-looking page on a jku.at address.
 *
 * Redirecting to /JKU-webshop reuses what already exists: {@link canActivateJkuSso} sends an
 * unauthenticated visitor straight to myJKU via `kc_idp_hint`, and the child route is the
 * licence-plate registration form. That is the journey the webshop concept draws — JKU homepage →
 * Quicklinks "Parken" → "Anmelden bei myJKU" → "Kennzeichen registrieren" (V06, slides 7-9).
 *
 * Only the root path is affected; deep links into /my-account and the rest still work on the JKU
 * hostname, and parker.jjames.eu is untouched.
 */
export const canActivateParkerHome: CanActivateFn = (): boolean | UrlTree => {
  if (isJkuHost()) {
    return inject(Router).parseUrl('/JKU-webshop');
  }
  return true;
};
